import type { OverrideMap } from '#screens/hosts/hooks/useOverrideMaps.ts';
import { mapOverridesToForm } from '../form/advanced/mappers/mapOverridesToForm.ts';

export function makeOverrideDefaults(overrideMap: OverrideMap) {
  const tagValues = [...overrideMap.values()].map((o) => o.value);
  return mapOverridesToForm(tagValues);
}
